module.exports = __webpack_public_path__ + "img/selection-or-1.5d25c6b0.webp";